import axiosClient from 'api/axiosClient';
import endpoints from 'api/endpoints';

export const getCategories = () => {
  return axiosClient.get(endpoints.CATEGORIES);
};

export const getCategoryById = (id) => {
  return axiosClient.get(`${endpoints.CATEGORIES}/${id}`);
};

export const fetchSubcategories = (categoryId) => {
  return axiosClient.get(endpoints.SUBCATEGORIES(categoryId));
};
